import StaticCrumb from '../components/StaticCrumb';
import TemplateCrumb from '../components/TemplateCrumb';
import { BreadcrumbRouteConfig } from '../types';

export const templatesRoutes: BreadcrumbRouteConfig = {
    path: '/agents/:agentId/templates',
    breadcrumbs: [
        {
            component: StaticCrumb,
            props: {
                label: 'Templates',
                href: '/agents/:agentId/templates',
            },
        },
    ],
    children: [
        {
            path: 'new',
            breadcrumbs: [
                {
                    component: StaticCrumb,
                    props: { label: 'New', isCurrentPage: true },
                },
            ],
        },
        {
            path: ':templateId/versions/:versionId',
            breadcrumbs: [
                {
                    component: TemplateCrumb,
                    props: {
                        param: 'templateId',
                        isCurrentPage: true,
                    },
                },
            ],
        },
    ],
};
